<div class="sia-file-system-panel-header" #archivesSelectHeight>
  <sia-select-box
    [selectBoxOptions]="{
      disableEmptyElement: true,
      orderByAsc: false,
      fixedDataSource: archivesDataSource,
      value: selectedArchive?.id,
    }"
    label="ARCHIVI"
    (valueChanged)="selectedArchiveChanged($event)"
    [value]="selectedArchive?.id"
    #selectBoxArchivesEl
    [style]="'width: 100%; display: inline-block'"
  ></sia-select-box>
</div>

@if (selectedArchive) {
  <sia-core-file-system
    [pathDescription]="selectedArchive.description"
    [originalPath]="path"
    [path]="path"
    [showFileTree]="true"
    [showName]="false"
    [style]="
      'height: calc(100% - ' +
      archivesSelectHeight.offsetHeight +
      'px); display: block'
    "
  ></sia-core-file-system>
}
